// src/api/userApi.js
import { ISignIn, IUserInfo } from "@utils/Interfaces";
import { apiClient, apiGoogle } from "./ApiConfig";
import { buildFeedbackQuery } from "./FeedbackApi";
import type { FeedbackQuery } from "./FeedbackApi";

const userApi = {
  fetchUserGoogle: (token: string) => {
    return apiGoogle.get("/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  createUser: (data: IUserInfo) => {
    return apiClient.post("/auth/v2/user", data);
  },
  checkEmail: (email: string) => {
    return apiClient.get(`/auth/check-email?email=${email}`);
  },
  signIn: (body: ISignIn) => {
    return apiClient.post("/auth/login", body);
  },
  googleSignIn: (body: { code: string; redirect_uri?: string } | any) => {
    return apiClient.post("/auth/google-login", body);
  },
  updateUserProfile: (body: any) => {
    return apiClient.post("/user/update_profile", body);
  },
  updateFarmProfile: (body: any) => {
    return apiClient.post("/user/v2/update_farm_profile", body);
  },
  changePassword: (body: any) => {
    return apiClient.post("/user/change_password", body);
  },
  changeLocalization: (body: any) => {
    return apiClient.post("/user/localization", body);
  },
  deleteAccount: (body: any) => {
    return apiClient.post("/auth/delete", body);
  },
  verifyOtp: (body: any) => {
    return apiClient.post("/auth/verify", body);
  },
  resendOtp: (body: any) => {
    return apiClient.post("/auth/resend-otp", body);
  },
  getProducers: () => {
    return apiClient.get("/user/producers");
  },
  GetPaginated: (current: number, pageSize: number) => {
    return apiClient.get(
      `/user/producers/paginated?page=${current}&limit=${pageSize}`
    );
  },
  getProducerDetail: (id: number) => {
    return apiClient.get(`/producer/detail?producer_id=${id}`);
  },
  getProducerFeedback: (producerId: number, params?: FeedbackQuery) => {
    return apiClient.get(
      `/feedback/producer/${producerId}${buildFeedbackQuery(params)}`
    );
  },
  getProducerFeedbackSummary: (producerId: number) => {
    return apiClient.get(`/feedback/producer/${producerId}/summary`);
  },
  getAllAddress: () => {
    return apiClient.get("/user/addresses");
  },
  updateAddress: (body: any) => {
    return apiClient.post("/user/update_address", body);
  },
  addAddress: (body: any) => {
    return apiClient.post("/user/add_address", body);
  },
  deleteAddress: (body: any) => {
    return apiClient.post("/user/delete_address", body);
  },
  setWatchlistNotificationPreference: (enabled: boolean) => {
    // TODO: replace with the BE notification-preference endpoint when it lands.
    console.log("setWatchlistNotificationPreference", enabled);
    return Promise.resolve({ status: 200, data: { enabled } });
  },
};

export default userApi;
